'use strict';

import React from 'react';
import {h, Fragment} from 'preact';
import {withRouter, Route, Link, Switch, Redirect} from 'react-router-dom';
import TechModels from './components/models/Tech';
import Models from './components/models/Models';

global = typeof global !== 'undefined' ? global : window;

const App = ({context, location}) => {
    const appContext = context.appContext;

    global.config = typeof window !== 'undefined' ? window.appConfig : appContext.config;

    const langPrefix = global.config.lang === 'ua' ? '/:lang' : '';

    return (
        <Switch>
            <Route
                exact
                path={`${langPrefix}/:tech/:brand/`}
                render={props => <TechModels {...appContext.pageData} {...props} />}
            />

            <Route
                exact
                path={`${langPrefix}/:brand/:tech/:model/`}
                render={props => <Models {...appContext.pageData} {...props} />}
            />

            <Route
                render={() => {
                    typeof window !== 'undefined' ? (window.location = location.pathname) : '';
                }}
            />
        </Switch>
    );
};

export default withRouter(App);
